<template>

    <div>
        <v-progress-circular
            indeterminate
            color="primary"
            class="mx-3"
        ></v-progress-circular>
        <span v-if="text" v-text="text"></span>
        <span v-else>Just a moment...</span>
    </div>

</template>

<script>

export default {

    props: {
        text: {required: true},
    }

}

</script>
